import React, { useState, useRef, useEffect, useContext } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { ArrowLeft, ArrowRight } from '@mui/icons-material';
import { GalleryCard } from '../../api/Queries/get';
import { useLocation } from 'react-router-dom';
import { Context } from '../../Store/context';

const GallerySlider = () => {
  const [sliderData, setSliderData] = useState(null)
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const location = useLocation().pathname.split('/')[2];
  const { showError } = useContext(Context);
  const mainSliderRef = useRef(null);
  const thumbSliderRef = useRef(null);


  useEffect(() => {
    const getNewsTable = async () => {
      try {
        const res = await GalleryCard(location)
        setSliderData(res.data)
      } catch (error) {
        showError(error.message);
      }
    }
    getNewsTable()
  }, [location, showError])

  const isMultipleImages = sliderData?.images?.length > 1;

  // Settings for the Main Slider
  const mainSliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: false,
    beforeChange: (current, next) => {
      setCurrentImageIndex(next);
      if (thumbSliderRef.current) {
        thumbSliderRef.current.slickGoTo(next);
      }
    },
  };

  // Settings for the Thumbnail Slider
  const thumbSliderSettings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 1,
    arrows: false,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 1024, 
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 768, 
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 480, 
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  };

  // Function to handle slide to the previous image
  const goToPrevSlide = () => {
    if (mainSliderRef.current) {
      mainSliderRef.current.slickPrev();
    }
  };

  // Function to handle slide to the next image
  const goToNextSlide = () => {
    if (mainSliderRef.current) {
      mainSliderRef.current.slickNext();
    }
  };

  // Function to handle clicking a thumbnail
  const handleThumbnailClick = (index) => {
    if (mainSliderRef.current) {
      mainSliderRef.current.slickGoTo(index);
      setCurrentImageIndex(index);
    }
  };

  return (
    <div className="absolute w-[100%] xl:w-[80%] flex 
                   flex-col text-center gap-6">
      {/* Custom Navigation Arrows for Main Slider */}
      <div className="imgSlider-button flex justify-between mb-4">
        <button
          onClick={goToPrevSlide}
          className="left-button p-2 rounded-full"
        >
          <ArrowLeft />
        </button>
        <button
          onClick={goToNextSlide}
          className="right-button p-2 rounded-full"
        >
          <ArrowRight />
        </button>
      </div >
      {/* Main Slider */}
      {isMultipleImages ? (
        <Slider
          {...mainSliderSettings}
          ref={mainSliderRef}
          className="w-full border-bottom"
        >
          {sliderData?.images?.map((image, i) => (
            <div key={i} className="relative">
              <img
                src={image.image}
                alt={`Slide ${i + 1}`}
                className="w-full h-[240px] md:h-[350px] xl:h-[600px]
                           rounded-2xl object-contain" />
            </div>
          ))}
        </Slider>
      ) : (
        <div className="relative">
          <img
            src={sliderData?.images[0]?.image}
            alt="Slide"
            className="w-full h-[240px] md:h-[350px] xl:h-[500px]
                       rounded-2xl object-contain" />
        </div>
      )}
      {/* Custom Navigation Arrows for Thumbnail Slider */}
      <div className="relative border border-border 
                      dark:border-dark-border p-2 w-full">
        <button
          onClick={goToPrevSlide}
          className="left-button2 p-2"
        >
          <ArrowLeft />
        </button>
        <button
          onClick={goToNextSlide}
          className="right-button2 p-2 mr-2 "
        >
          <ArrowRight />
        </button>

        {/* Thumbnail Slider */}
        <Slider
          {...thumbSliderSettings}
          ref={thumbSliderRef}
          className="w-full"
        >
          {sliderData?.images?.map((image, i) => (
            <div
              key={i}
              className="px-2"
              onClick={() => handleThumbnailClick(i)}
            >
              <img
                src={image.image}
                alt={`Slide ${i + 1}`}
                className={`h-[100px] w-[200px] md:w-[220px] md:h-[120px] cursor-pointer
                            object-cover border border-b  transition-all duration-300
                            ${currentImageIndex === i ? 'border-none'
                                                      : 'opacity-50 border-secondary'}
                            hover:border-primary hover:opacity-70`}
              />
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default GallerySlider;

